export { DeviceTablet as default } from './DeviceTablet';
